import { FC, memo } from 'react';
import { IconProps } from '@tempusfinance/common-ui';
import {
  Alert,
  Analytics,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  BoostArrow,
  BoostStars,
  Checkmark,
  Close,
  Coin,
  Copy,
  Degen,
  Delete,
  Discord,
  Edit,
  Exit,
  Experimental,
  ExternalLink,
  GitBook,
  Home,
  Info,
  LeftChevron,
  Loading,
  Loading2,
  Lock,
  Menu,
  Nostra,
  NumberOne,
  Percent,
  Plus,
  Pool,
  RightChevron,
  Search,
  Settings,
  Share,
  SlippageIcon,
  SpringRewards,
  Stake,
  Swap,
  UpChevron,
  XIcon,
  SupplyCapError,
  SupplyCapWarning,
  Pin,
  PinSolid,
  Exclamation,
  DownChevron,
  Filter,
  Refresh,
  BridgeIcon,
  Gas,
  TriangleUp,
  TriangleDown,
  TransactionDepositAndStake,
  TransactionWithdrawAndUnstake,
  TransactionSwap,
  TransactionAdjust,
  TransactionBorrow,
  TransactionRepay,
  TransactionBridge,
  More,
  Chart,
  SupplyCapLimit,
  Airdrop,
} from './icons';

export type IconVariant =
  | 'home'
  | 'stake'
  | 'coin'
  | 'swap'
  | 'pool'
  | 'arrow-up'
  | 'number-one'
  | 'analytics'
  | 'discord'
  | 'x'
  | 'git-book'
  | 'slippage'
  | 'percent'
  | 'alert'
  | 'lock'
  | 'settings'
  | 'down-chevron'
  | 'search'
  | 'close'
  | 'up-chevron'
  | 'left-chevron'
  | 'right-chevron'
  | 'boost-stars'
  | 'boost-arrow'
  | 'arrow-left'
  | 'arrow-right'
  | 'degen'
  | 'experimental'
  | 'plus'
  | 'info'
  | 'external-link'
  | 'nostra'
  | 'arrow-down'
  | 'share'
  | 'copy'
  | 'menu'
  | 'exit'
  | 'edit'
  | 'delete'
  | 'checkmark'
  | 'loading'
  | 'loading2'
  | 'spring-rewards'
  | 'airdrop'
  | 'supply-cap-warning'
  | 'supply-cap-error'
  | 'pin'
  | 'pin-solid'
  | 'exclamation'
  | 'filter'
  | 'refresh'
  | 'bridge'
  | 'gas'
  | 'triangle-up'
  | 'triangle-down'
  | 'transaction-deposit-and-stake'
  | 'transaction-withdraw-and-unstake'
  | 'transaction-swap'
  | 'transaction-adjust'
  | 'transaction-borrow'
  | 'transaction-repay'
  | 'transaction-bridge'
  | 'more'
  | 'chart'
  | 'supply-cap-limit';

const IconComponent: FC<IconProps & { variant: IconVariant }> = props => {
  switch (props.variant) {
    case 'home':
      return <Home {...props} />;
    case 'stake':
      return <Stake {...props} />;
    case 'coin':
      return <Coin {...props} />;
    case 'swap':
      return <Swap {...props} />;
    case 'pool':
      return <Pool {...props} />;
    case 'arrow-up':
      return <ArrowUp {...props} />;
    case 'number-one':
      return <NumberOne {...props} />;
    case 'analytics':
      return <Analytics {...props} />;
    case 'discord':
      return <Discord {...props} />;
    case 'x':
      return <XIcon {...props} />;
    case 'git-book':
      return <GitBook {...props} />;
    case 'slippage':
      return <SlippageIcon {...props} />;
    case 'percent':
      return <Percent {...props} />;
    case 'alert':
      return <Alert {...props} />;
    case 'lock':
      return <Lock {...props} />;
    case 'settings':
      return <Settings {...props} />;
    case 'down-chevron':
      return <DownChevron {...props} />;
    case 'search':
      return <Search {...props} />;
    case 'close':
      return <Close {...props} />;
    case 'up-chevron':
      return <UpChevron {...props} />;
    case 'left-chevron':
      return <LeftChevron {...props} />;
    case 'right-chevron':
      return <RightChevron {...props} />;
    case 'boost-stars':
      return <BoostStars {...props} />;
    case 'boost-arrow':
      return <BoostArrow {...props} />;
    case 'arrow-left':
      return <ArrowLeft {...props} />;
    case 'arrow-right':
      return <ArrowRight {...props} />;
    case 'degen':
      return <Degen {...props} />;
    case 'experimental':
      return <Experimental {...props} />;
    case 'plus':
      return <Plus {...props} />;
    case 'info':
      return <Info {...props} />;
    case 'external-link':
      return <ExternalLink {...props} />;
    case 'nostra':
      return <Nostra {...props} />;
    case 'arrow-down':
      return <ArrowDown {...props} />;
    case 'share':
      return <Share {...props} />;
    case 'copy':
      return <Copy {...props} />;
    case 'menu':
      return <Menu {...props} />;
    case 'exit':
      return <Exit {...props} />;
    case 'edit':
      return <Edit {...props} />;
    case 'delete':
      return <Delete {...props} />;
    case 'checkmark':
      return <Checkmark {...props} />;
    case 'loading':
      return <Loading {...props} />;
    case 'loading2':
      return <Loading2 {...props} />;
    case 'spring-rewards':
      return <SpringRewards {...props} />;
    case 'airdrop':
      return <Airdrop {...props} />;
    case 'supply-cap-warning':
      return <SupplyCapWarning {...props} />;
    case 'supply-cap-error':
      return <SupplyCapError {...props} />;
    case 'supply-cap-limit':
      return <SupplyCapLimit {...props} />;
    case 'pin':
      return <Pin {...props} />;
    case 'pin-solid':
      return <PinSolid {...props} />;
    case 'exclamation':
      return <Exclamation {...props} />;
    case 'filter':
      return <Filter {...props} />;
    case 'refresh':
      return <Refresh {...props} />;
    case 'bridge':
      return <BridgeIcon {...props} />;
    case 'gas':
      return <Gas {...props} />;
    case 'triangle-up':
      return <TriangleUp {...props} />;
    case 'triangle-down':
      return <TriangleDown {...props} />;
    case 'transaction-deposit-and-stake':
      return <TransactionDepositAndStake {...props} />;
    case 'transaction-withdraw-and-unstake':
      return <TransactionWithdrawAndUnstake {...props} />;
    case 'transaction-swap':
      return <TransactionSwap {...props} />;
    case 'transaction-adjust':
      return <TransactionAdjust {...props} />;
    case 'transaction-borrow':
      return <TransactionBorrow {...props} />;
    case 'transaction-repay':
      return <TransactionRepay {...props} />;
    case 'transaction-bridge':
      return <TransactionBridge {...props} />;
    case 'more':
      return <More {...props} />;
    case 'chart':
      return <Chart {...props} />;
    default:
      return null;
  }
};

export const Icon = memo(IconComponent);
